export default __webpack_public_path__ + "static/media/package-img3.420f2891.jpg";